import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TUS CREDENCIALES (Las originales que funcionan)
const firebaseConfig = {
  apiKey: "AIzaSyCi9vPJstOzEqZhra1KYGpEfJmfqSSoXG0",
  authDomain: "valle-del-sol-app.firebaseapp.com",
  projectId: "valle-del-sol-app",
  storageBucket: "valle-del-sol-app.firebasestorage.app",
  messagingSenderId: "479200827108",
  appId: "1:479200827108:web:839d91483bd9421fd33ef1",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar solo Auth y Firestore
export const auth = getAuth(app);
export const db = getFirestore(app);

// Lógica original de App ID (Estable)
export const appId =
  typeof window !== "undefined" && window.__app_id
    ? window.__app_id
    : "default-app-id";

export default app;
